function EvnVar() {
  const rootURI = {
    // baseURL: "http://192.168.1.3:3000/node/api",
    baseURL: "https://vitiyagyanmela.icai.org/node/api",
  };

  return rootURI.baseURL;
}

// export function newEvn() { return 'http://192.168.1.3:3000' }
export function newEvn() {
  return "https://vitiyagyanmela.icai.org";
}

export default EvnVar;
